import {Stack} from 'shells/layout/stack/stack';
import {LoadingText} from 'shells/loading-placeholder/loading-text';
import {Body} from 'shells/typography/body';

import type {
    GetLimits_limits,
    GetAvailablePlans_recurlyAvailablePlans_crm_plans as Plan,
} from 'nutshell-graphql-types';

import {getPlanPill} from './helpers';
import {PlanCard} from './plan-card';

interface Props {
    limits: GetLimits_limits | null;
    featureName?: string;
    isLoading: boolean;
    upgradePlan: Plan | undefined;
    planName: string;
}

export function NotInPlanAdminContent(props: Props) {
    return (
        <Stack spacing={16}>
            <Body size='xlarge' isBold={true} color='dark'>
                Upgrade your plan to use
                {props.featureName ? ` ${props.featureName}` : ' this feature'}
            </Body>
            {props.isLoading ? (
                <Stack spacing={6}>
                    <LoadingText isFullWidth={true} />
                    <LoadingText width={300} />
                    <LoadingText width={200} />
                </Stack>
            ) : (
                props.upgradePlan?.description && <Body>{props.upgradePlan.description}</Body>
            )}
            {props.isLoading ? (
                <LoadingText height={250} isFullWidth={true} />
            ) : (
                props.planName &&
                props.upgradePlan && (
                    <PlanCard
                        planPill={getPlanPill(props.planName)}
                        label='Recommended'
                        pricePerUser={`$${props.upgradePlan.price}`}
                        priceUnit={props.upgradePlan.priceUnit ?? undefined}
                        bullets={props.upgradePlan.planHighlights}
                    />
                )
            )}
        </Stack>
    );
}
